import { useEffect } from 'react';
import { GA_EVENTS } from '@/utils/analytics';

export const useScrollTracking = () => {
  useEffect(() => {
    let maxScrollDepth = 0;
    const scrollThresholds = [25, 50, 75, 90, 100];
    const trackedThresholds = new Set<number>();

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;

      // 페이지 높이가 뷰포트보다 작거나 같으면 스크롤 추적을 건너뜀
      if (documentHeight <= 0) {
        return;
      }

      const scrollDepth = Math.round((scrollTop / documentHeight) * 100);

      // scrollDepth가 유효한 범위(0-100) 내에 있는지 확인
      if (scrollDepth < 0 || scrollDepth > 100 || !isFinite(scrollDepth)) {
        return;
      }

      if (scrollDepth > maxScrollDepth) {
        maxScrollDepth = scrollDepth;
      }

      // 스크롤 깊이 임계값 추적
      scrollThresholds.forEach(threshold => {
        if (scrollDepth >= threshold && !trackedThresholds.has(threshold)) {
          trackedThresholds.add(threshold);
          GA_EVENTS.SCROLL_DEPTH(threshold);
        }
      });
    };

    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', handleScroll, { passive: true });

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
};
